import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Logo from "../../assets/logo-inscription.png";
import { t } from "../../translations";
import "../styles/section-sign-up.css";

const SectionSignUp = () => {
  const history = useHistory();

  let lang = useSelector((state) => state.lang);

  const text1 = t("section_sign_up.text1", lang);
  const text2 = t("section_sign_up.text2", lang);

  return (
    <div className="section-principal">
      <hr />
      <div className="section-sign-up">
        <div className="text-sign-up">
          <p>{text1}</p>
          <p>{text2}</p>
        </div>
        <img
          src={Logo}
          alt=""
          onClick={() => {
            return history.push("/chef/iam-a-chef/home");
          }}
        />
      </div>
      <hr />
    </div>
  );
};

export default SectionSignUp;
